<template>
  <div class="regulamento">
    <BannerRegulamento/>
    <TextRegulamento/>
  </div>
</template>

<script>
import BannerRegulamento from '@/wrappers/BannerRegulamento'
import TextRegulamento from '@/wrappers/TextRegulamento'
export default {
  name: 'regulamento',
  components: {
    BannerRegulamento,
    TextRegulamento,
  }
}
</script>